import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { DATE_INPUT_FORMAT } from '@app/utils/constants/date-input-format';

// App-wide: datepicker inputs type and show `DATE_INPUT_FORMAT`; calendars keep their native labels.
export const DATE_INPUT_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: { ...MAT_NATIVE_DATE_FORMATS.display, dateInput: DATE_INPUT_FORMAT },
  parse: { ...MAT_NATIVE_DATE_FORMATS.parse, dateInput: DATE_INPUT_FORMAT },
};
